import React from 'react';
import { connect } from 'react-redux';

import filterActiveStylists from 'bl/data/filterActiveStylists.bl';
import determineDisplayNumberOf from 'bl/timeoff/determineDisplayNumberOf.bl';
import { useTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';
import { selectCurrentSalonStylists } from 'selectors/currentSalon.selectors';
import { selectTimeOffReport } from 'selectors/timeoff.selectors';
import asArray from 'utils/arrays/asArray.util';
import asObject from 'utils/objects/asObject.util';
import createNodeKey from 'utils/react/createNodeKey.util';

import CN from './StylistAllowancesExcelTable.module.scss';

const EMPTY = '';

const StylistAllowancesExcelTable = ({ headers, stylists, report, isHoursSelected }) => {
  const { t } = useTranslation();
  return (
    <table data-bem="StylistAllowancesExcelTable__TimeOffExcel" id="TimeOffExcel" className={CN.hidden}>
      <thead>
        <tr>
          <th>
            <table>
              <thead>
                <tr>
                  {asArray(headers).map((header, index) => (
                    <th key={createNodeKey({ index })}>{header}</th>
                  ))}
                </tr>
              </thead>
            </table>
          </th>
        </tr>
      </thead>
      <tbody>
        {filterActiveStylists(stylists).map((s) => {
          const { id: stylistId, user_name: userName, is_self_employed: isSelf } = asObject(s);
          const selfEmployedText = t('staffKpisReports.reportsTimeOff.selfEmployedStatus');
          const employedText = t('staffKpisReports.reportsTimeOff.employedStatus');
          const displayStylist = `${userName} - ${isSelf ? selfEmployedText : employedText}`;
          const stylistData = asObject(report)[stylistId];

          return (
            <tr key={s.id}>
              <td>
                <table>
                  <thead>
                    <tr>
                      <th>{displayStylist}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.values(asObject(stylistData)).map(
                      ({
                        categoryId,
                        categoryName,
                        allowanceDays,
                        allowanceHours,
                        usedDays,
                        excessDays,
                        excessHours,
                        remainingDays,
                        remainingHours,
                        upcomingDays,
                        upcomingHours,
                        usedHours,
                      }) => {
                        const displayUsed = determineDisplayNumberOf({
                          isHoursSelected,
                          hours: usedHours,
                          days: usedDays,
                          defaultValue: EMPTY,
                        });
                        const displayUpcoming = determineDisplayNumberOf({
                          isHoursSelected,
                          hours: upcomingHours,
                          days: upcomingDays,
                          defaultValue: EMPTY,
                        });
                        const displayAllowance = determineDisplayNumberOf({
                          isHoursSelected,
                          hours: allowanceHours,
                          days: allowanceDays,
                          defaultValue: EMPTY,
                        });
                        const displayRemaining = determineDisplayNumberOf({
                          isHoursSelected,
                          hours: remainingHours,
                          days: remainingDays,
                          defaultValue: EMPTY,
                        });
                        const displayExcess = determineDisplayNumberOf({
                          isHoursSelected,
                          hours: excessHours,
                          days: excessDays,
                          defaultValue: EMPTY,
                        });

                        return (
                          <tr key={categoryId}>
                            <td>{categoryName}</td>
                            <td>{displayAllowance}</td>
                            <td>
                              <span className={CN.emphasis}>{displayUsed}</span>
                            </td>
                            <td>
                              <span className={CN.emphasis}>{displayUpcoming}</span>
                            </td>
                            <td>{displayRemaining}</td>
                            <td>{displayExcess}</td>
                          </tr>
                        );
                      },
                    )}
                  </tbody>
                </table>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const mapStateToProps = (state) => ({
  stylists: selectCurrentSalonStylists(state),
  report: selectTimeOffReport(state),
});

const StylistAllowancesExcelTableHoc = connect(mapStateToProps)(withTheme()(StylistAllowancesExcelTable));

export default StylistAllowancesExcelTableHoc;
